import type { CustomerReferenceTag } from '~/types'

export const useCustomerReferences = () => {
  const { feature } = useCountryConfig()

  const hasCustomerReference = (references: Array<CustomerReferenceTag> | null | undefined): boolean => {
    const refs = references ?? []

    // When feature.displayPharmacyReference = false, filter out PHARMACY references - only OFFICE is valid
    if (!feature.displayPharmacyReference) {
      const validRefs = refs.filter(ref => ref !== 'pharmacy')
      return validRefs.length > 0
    }
    return refs.length > 0
  }

  return {
    hasCustomerReference,
  }
}
